import moment from 'moment'
import filesize from 'filesize'

export default class NodeVersion {
  constructor (data) {
    this.id = typeof data === 'undefined' ? null : data.id
    this.name = typeof data === 'undefined' ? null : data.name
    this.path = typeof data === 'undefined' ? null : data.path
    this.file = typeof data === 'undefined' ? null : data.file
    this.version = typeof data === 'undefined' ? null : data.version
    this.node = typeof data === 'undefined' ? null : data.node
  }

  get type () {
    return !this.file ? 'dir' : 'file'
  }

  get lastUpdate () {
    return this.version ? moment(this.version.date) : null
  }

  get authorName () {
    return this.version && this.version.author ? this.version.author.email : null
  }

  get size () {
    return this.file ? this.file.size : null
  }

  get humanizeSize () {
    return this.file ? filesize(this.file.size) : null
  }

  clone () {
    return new NodeVersion(JSON.parse(JSON.stringify(this)))
  }
}



// WEBPACK FOOTER //
// ./src/files/entity/NodeVersion.js